import { adsConfig } from '../ads';
import {
  MarketConfig,
  PaymentProviderGroup,
  PrivacySettingToggle,
} from './types';

export const fi: MarketConfig = {
  countryCode: 'fi',
  active: true,
  sitename: 'Hintaopas',
  permanentRedirect: true,
  redirectHosts: ['m.hintaopas.fi', 'www.hintaopas.fi'],
  superSearchEndpoint: 'https://search.cloud.pji.nu/rfe',
  trackerProxy: 'rfe-tracker-2069617015.eu-west-1.elb.amazonaws.com',
  useClassicUrls: true,
  classicProxy: {
    host: 'int-classic-fi.prisjakt.io',
    port: 8080,
  },
  hrefLang: ['fi'],
  locale: 'fi',
  localeStandard: 'fi-FI',
  sites: {
    production: 'https://hintaopas.fi',
    classic: 'https://classic.hintaopas.fi',
    analytics: 'https://classic.hintaopas.fi/analytics/store/',
    brands: undefined,
    forum: undefined,
    mobile: undefined,
  },
  api: {
    default: 'http://int-api-fi.cloud.pji.nu:8080/v1',
  },
  campaigns: {
    base:
      'https://search-pj-campaigns-index-oyaq7ruf3du2owxiiiuhyqcgcm.eu-west-1.es.amazonaws.com',
    previousCampaignDates: {
      '2': '2019-11-29', // BF
      '6': '2019-12-02', // CM
      '3': '2019-12-25', // Boxing day
      '16': '2020-11-11', // Singles Day
    },
  },
  googleTagManager: 'GTM-KD9S55X',
  translation: 'fi',
  timezone: 'Europe/Helsinki',
  currencyCode: 'EUR',
  url: {
    campaigns: '/teema',
    legacy: {
      brand: '/brand.php',
      category: '/category.php',
      fight: '/fight.php',
      forum: undefined,
      info: '/info.php',
      lists: '/lists.php',
      minhembio: undefined,
      plugin: '/plugins/',
      product: '/product.php',
      raw: '/raw.php',
      store_info: '/shop.php',
      user_login: '/login/login.php',
      mobile_site: 'https://m.hintaopas.fi',
    },
  },
  socialNetworks: {
    instagram: {
      link: 'https://www.instagram.com/hintaopas/',
    },
    facebook: {
      enableLogin: true,
      link: 'https://www.facebook.com/hintaopas',
      clientID: '710896249045606',
      clientSecret: 'c7b631aafeaf2e676015b58054e66aa6',
      callbackURL: `/_internal/auth/facebook/callback`,
    },
    twitter: {
      link: 'https://twitter.com/Hintaopas_FI',
      consumerKey: 'zzPeHh9JNoDX9dyQEzuyLbU5M',
      consumerSecret: 'J1jL0ZWYc59dFHUb1wVgt6Isrd0NKX5PsSerwrdiAWJNChWReF',
      callbackURL: `/_internal/auth/twitter/callback`,
    },
    schibsted: {
      enableLogin: false,
      clientID: '5f5f8396cab19b071816d268',
      clientSecret: 'Q4QAYLcgX7IyAwl9khEE',
      host: 'https://login.schibsted.com',
      callbackURL: '/_internal/auth/schibsted/callback',
    },
  },
  schibstedOtherSitesLinks: [
    {
      name: 'Tori,',
      siteUrl: 'https://www.tori.fi/',
    },
    {
      name: 'Lendo,',
      siteUrl: 'https://www.lendo.fi/',
    },
    {
      name: 'Oikotie,',
      siteUrl: 'https://oikotie.fi/',
    },
    {
      name: 'Rakentaja',
      siteUrl: 'https://www.rakentaja.fi/',
    },
  ],
  email: {
    noreply: 'noreply@hintaopas.fi',
  },
  cdn: {
    base: 'https://pricespy-75b8.kxcdn.com',
    images: 'https://pricespy-75b8.kxcdn.com/',
    offerImages: 'https://www.prisjakt.nu/offers-images',
  },
  routes: {
    themes: {
      path: '/teema',
    },
    campaign: {
      path: '/teema/:name',
    },
    shopOfTheYear: {
      path: '/vuoden-verkkokauppa',
    },
    shopOfTheYearCategory: {
      path: '/vuoden-verkkokauppa/:year/category/:id',
    },
    shopOfTheYearWinners: {
      path: '/vuoden-verkkokauppa/:section',
    },
    productCompare: {
      path: '/vertaa/tuotteet/:productIds?',
    },
    editorialContentListing: {
      path: '/artikkeleita',
    },
    categoryIndex: {
      path: '/tuotekategoriat',
    },
  },
  popularCampaignFilterPaths: [
    {
      title: 'Sykemittarit ja älykellot - parhaat tarjoukset',
      path: '?sort=product.popularity.total&category=1942',
    },
    {
      title: 'Matkapuhelimet ja kuulokkeet',
      path: '?category=103%7C148',
    },
    {
      title: 'Juoksukengät ja tennarit – parhaat tarjoukset',
      path: '?sort=product.popularity.total&category=1428%7C1497',
    },
    {
      title: 'Parhaat tarjoukset alle 50€',
      path: '?price=0-50',
    },
    {
      title: 'Keittiö & kodinkoneet - parhaat tarjoukset',
      path: '?category=1671%7C504',
    },
    {
      title: 'Televisiot',
      path: '?category=107',
    },
  ],

  infoPages: [9, 5, 15, 10, 12, 4, 6, 14, 7, 8],
  infoPageMap: {
    userAgreement: 4,
    priceInformation: 5,
    privacyPolicy: 6,
    cookiePolicy: 7,
    contact: 8,
    about: 9,
    registerShop: 10,
    media: 12,
    disclaimer: 14,
    aboutReviews: 15,
    adlink: 'adlink',
    themes: 'themes',
    articles: 'articles',
    shopOfTheYear: 'shopOfTheYear',
    categoryIndex: 'categoryIndex',
    newsroom: 'newsroom',
    blackFriday: 'blackFriday',
  },
  newsletter: {
    apiUrl: 'https://api.getanewsletter.com/v3/',
    apiKey:
      '8KV6mYjfJmudQnsQGIm1ba/oRw/hcDhaDiuvgz2yT8f8NfKzl017dhGEpHPOAxQVLiUq4ZibYSS9c6aQuWqaKjByShyixwZjSZgh1cJlSzvDdDx7G1L4+uo5UTV6TFV0xqRIUW4PmgCdXk16Cnzds6a4aImDyrsRO/8eszpZG2g8D5bNcy+t2xBU+eh1LFUZ96CJrs4DzWOMfIOrWs/F61fZJHU5GGNG6QVjiZ4STok+mUD+NEezTNHDVIySuT4',
    list: 'SBTmg',
    gansubFormId: 'mBEs',
  },
  apps: {
    ios: '369151774',
    android: 'se.prisjakt.pricespy',
  },
  ads: { active: true, ...adsConfig.fi },
  paymentProviders: {
    priorities: [
      'SWISH',
      'VIPPS',
      'PAYPAL',
      'KLARNA',
      'SVEA_WEB_PAY',
      'AMEX',
      'MASTER_CARD',
      'VISA',
      'DINERS',
    ],
    groupPriorities: [
      PaymentProviderGroup.Direct,
      PaymentProviderGroup.Invoice,
      PaymentProviderGroup.Card,
    ],
  },
  privacySettings: {
    responsive: {
      cookieVersion: '4',
      cookieUrl: '/info/evasteet--i7',
      privacyUrl: '/info/tietosuojakaytannot--i6',
      privacySettingsUrl: '/privacy-settings',
    },
    desktop: {
      cookieVersion: '4',
      cookieUrl: '/info.php?t=about_cookies',
      privacyUrl: '/info.php?t=about_privacy',
      privacySettingsUrl: '/privacy.php',
    },
    mobile: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
    native: {
      cookieVersion: 'hidden', // policy_banner
      cookieUrl: '/about/cookies',
      privacyUrl: '/about/privacy',
      privacySettingsUrl: '/privacy/settings',
    },
  },
  modules: {
    categoryInfo: {
      enabled: false,
    },
    userReviewPurchaseDate: {
      enabled: false,
    },
    readableProductInfo: {
      enabled: true,
    },
  },
  showSchibstedCoBranding: false,
  showClassicSwitch: false,
  trackingToggles: [
    { name: PrivacySettingToggle.BehaviourTrackingImprovement, default: true },
    { name: PrivacySettingToggle.BehaviorTrackingMarketing, default: false },
    { name: PrivacySettingToggle.BehaviorTrackingSurveys, default: true },
    { name: PrivacySettingToggle.PersonalizedAds, default: true },
    { name: PrivacySettingToggle.Personalization, default: true },
  ],
  shopOfTheYear: true,
  cdnCache: {
    enabled: true,
    mode: 'external',
  },
  experts: {
    enabled: false,
  },
  keywordLandingPagesEnabled: true,
  featuredCollectionsEnabled: true,
};
